var map = {
	"./EmptyList.png": 809,
	"./appointment.png": 810,
	"./business-report.png": 811,
	"./consulting.png": 812,
	"./data-management.png": 813,
	"./dollar.png": 814,
	"./folder.png": 815,
	"./health-check.png": 816,
	"./hospital.png": 817,
	"./house.png": 818,
	"./medical-history.png": 819,
	"./medical-team.png": 820,
	"./painDegree1.png": 385,
	"./painDegree2.png": 386,
	"./painDegree3.png": 387,
	"./painDegree4.png": 388,
	"./painDegree5.png": 389,
	"./patient.png": 821,
	"./profit.png": 822,
	"./saving.png": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 808;